module.exports = __webpack_public_path__ + "134f5058196310e5b22350b2d96de6a1.svg";